module.exports = __webpack_public_path__ + "img/konfortify-banner.0de8986a.png";